import axios from 'axios';
import { getToken } from './auth';

const API_URL = `${process.env.REACT_APP_API_URL}/api`;

const authHeader = () => ({
  Authorization: `Bearer ${getToken()}`
});

axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userData");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fetchCategorias = () => axios.get(`${API_URL}/categorias/all`);
export const fetchProductos  = () => axios.get(`${API_URL}/productos/all`);
export const fetchEstadisticas = () =>
  axios.get(`${API_URL}/busqueda/estadisticas`, { headers: authHeader() });

export const insertProducto = (producto) => {
  const formData = new FormData();
  Object.keys(producto).forEach(key => {
    if (key !== "imagen") formData.append(key, producto[key]);
  });
  return axios.post(`${API_URL}/productos/insert`, formData, { headers: authHeader() });
};

export const buscarProducto = (termino) =>
  axios.get(`${API_URL}/busqueda/buscar/${termino}`);

// Perfil del usuario logueado
export const fetchMiPerfil = () =>
  axios.get(`${API_URL}/users/me`, { headers: authHeader() });

// Checkout: crea venta PENDIENTE + preference MercadoPago
export const checkout = (items, total, datosEnvio) =>
  axios.post(`${API_URL}/ventas/checkout`, { items, total, ...datosEnvio }, { headers: authHeader() });

// Confirmar pago tras redirect de MercadoPago
export const confirmarPago = (ventaId, status, paymentId) =>
  axios.post(`${API_URL}/ventas/${ventaId}/confirmar-pago`, null, {
    params: { status, ...(paymentId && { paymentId }) }
  });

// Cliente: historial de compras propias
export const fetchMisCompras = () =>
  axios.get(`${API_URL}/ventas/mis-compras`, { headers: authHeader() });

// Admin: listar y actualizar ventas
export const fetchVentasAdmin = () =>
  axios.get(`${API_URL}/admin/ventas`, { headers: authHeader() });

export const actualizarEstadoVenta = (id, estadoEnvio) =>
  axios.put(`${API_URL}/admin/ventas/${id}/estado`, { estadoEnvio }, { headers: authHeader() });

// Productos: toggle activo/inactivo
export const toggleActivoProducto = (id) =>
  axios.patch(`${API_URL}/productos/${id}/toggle-activo`, {}, { headers: authHeader() });

// Direcciones del cliente
export const fetchMisDirecciones = () =>
  axios.get(`${API_URL}/direcciones`, { headers: authHeader() });

export const crearDireccion = (data) =>
  axios.post(`${API_URL}/direcciones`, data, { headers: authHeader() });

export const actualizarDireccion = (id, data) =>
  axios.put(`${API_URL}/direcciones/${id}`, data, { headers: authHeader() });

export const eliminarDireccion = (id) =>
  axios.delete(`${API_URL}/direcciones/${id}`, { headers: authHeader() });

export const marcarDireccionDefecto = (id) =>
  axios.patch(`${API_URL}/direcciones/${id}/default`, {}, { headers: authHeader() });

export const actualizarPerfil = (data) =>
  axios.put(`${API_URL}/users/me`, data, { headers: authHeader() });

// Contenido estático (quienes-somos, mision, vision)
export const fetchContenido = (clave) =>
  axios.get(`${API_URL}/contenido/${clave}`);

export const actualizarContenido = (clave, data) =>
  axios.put(`${API_URL}/contenido/${clave}`, data, { headers: authHeader() });

export async function apiFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const res = await fetch(url, { ...options, headers });
  if (!res.ok) throw new Error(`Error ${res.status}`);
  return res.json();
}
